export interface PasswordConfig {
  length: number;
  includeUppercase: boolean;
  includeLowercase: boolean;
  includeNumbers: boolean;
  includeSymbols: boolean;
  excludeAmbiguous: boolean;
  customSymbols?: string;
  minNumbers?: number;
  minSymbols?: number;
}

export interface GeneratedPassword {
  id: string;
  value: string;
  strength: PasswordStrength;
  config: PasswordConfig;
  generatedAt: Date;
}

export enum PasswordStrength {
  VERY_WEAK = 'very-weak',
  WEAK = 'weak',
  FAIR = 'fair',
  GOOD = 'good',
  STRONG = 'strong',
}

export interface PasswordPreset {
  name: string;
  description: string;
  icon: string;
  config: PasswordConfig;
}

export interface PasswordGenerationOptions {
  count: number;
  config: PasswordConfig;
}
